import React from 'react'
import { useSelector } from 'react-redux'
import MatrixMessageDelivery from 'matrix-react-sdk/lib/components/views/messages/MessageDelivery'
import { selectIsChatAvailableForCurrentWidget } from 'ducks/widgets/selectors'
import { deliveryStateOptions } from '../../utils/delivery'

export default function MessageDelivery(props) {
  const enabled = useSelector(selectIsChatAvailableForCurrentWidget)

  return (
    <MatrixMessageDelivery
      {...props}
      disableContextMenu={!enabled}
      deliveryStateOptions={deliveryStateOptions}
    />
  )
}
